/* Halflight Wellness — theme.js (no dependencies) */
(function () {
  'use strict';

  var T = window.theme || {};
  T.routes = T.routes || {};
  T.strings = T.strings || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ */
  /* Utilities                                                           */
  /* ------------------------------------------------------------------ */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function parseHtml(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* Shopify money format aware formatter (cents in) */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;
    var fmt = format || T.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  T.formatMoney = formatMoney;

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  T.toast = toast;

  /* ------------------------------------------------------------------ */
  /* Drawers                                                             */
  /* ------------------------------------------------------------------ */
  var lastFocus = null;
  var openDrawerEl = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(openDrawerEl, true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    openDrawerEl = drawer;
    setTimeout(function () {
      var f = $('[data-drawer-close]', drawer) || drawer;
      f.focus();
    }, 50);
  }
  function closeDrawer(drawer, keepOverlay) {
    drawer = drawer || openDrawerEl;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (!keepOverlay) {
      var overlay = $('[data-overlay]');
      if (overlay) overlay.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }
  T.openDrawer = openDrawer;
  T.closeDrawer = closeDrawer;

  on(document, 'click', function (e) {
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(closeBtn.closest('[data-drawer]')); return; }
    if (e.target.closest('[data-overlay]')) { closeDrawer(); return; }
    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && $('#CartDrawer') && T.cartType === 'drawer') { e.preventDefault(); openDrawer($('#CartDrawer')); return; }
    var wishOpen = e.target.closest('[data-wishlist-open]');
    if (wishOpen && $('#WishlistDrawer')) { e.preventDefault(); renderWishlist(); openDrawer($('#WishlistDrawer')); }
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape' && openDrawerEl) closeDrawer();
    if (e.key === 'Tab' && openDrawerEl) {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])', openDrawerEl)
        .filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Cart (AJAX API + Section Rendering)                                 */
  /* ------------------------------------------------------------------ */
  function drawerSectionIds() {
    return $('#CartDrawer') ? ['cart-drawer'] : [];
  }
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  function applyDrawerSection(html) {
    if (!html) return;
    var doc = parseHtml(html);
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      updateCounts(fresh.getAttribute('data-item-count') || 0);
    }
  }
  function refreshCountFromServer() {
    return fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCounts(c.item_count); return c; })
      .catch(function () {});
  }

  function addToCart(formData, button) {
    var ids = drawerSectionIds();
    if (ids.length) {
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          throw new Error(res.json.description || res.json.message || T.strings.error);
        }
        if (res.json.sections && res.json.sections['cart-drawer']) {
          applyDrawerSection(res.json.sections['cart-drawer']);
        } else {
          refreshCountFromServer();
        }
        var title = res.json.product_title || (res.json.items && res.json.items[0] && res.json.items[0].product_title) || '';
        toast((T.strings.added || 'Added to cart').replace('[title]', title));
        if (T.cartType === 'drawer' && $('#CartDrawer')) openDrawer($('#CartDrawer'));
        document.dispatchEvent(new CustomEvent('cart:added', { detail: res.json }));
        return res.json;
      })
      .catch(function (err) {
        toast(err.message || T.strings.error);
        throw err;
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
      });
  }
  T.addToCart = addToCart;

  on(document, 'submit', function (e) {
    var form = e.target;
    if (!form.matches || !(form.matches('form.js-ajax-add') || form.matches('form.js-product-form'))) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    addToCart(new FormData(form), btn).catch(function () {});
  });

  /* Buy now: add then go to checkout */
  on(document, 'click', function (e) {
    var buy = e.target.closest('[data-buy-now]');
    if (!buy) return;
    e.preventDefault();
    var form = document.getElementById(buy.getAttribute('data-form-id'));
    if (!form) return;
    var fd = new FormData(form);
    buy.classList.add('is-loading');
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || T.strings.error);
        window.location.href = '/checkout';
      })
      .catch(function (err) { toast(err.message); buy.classList.remove('is-loading'); });
  });

  function changeLine(line, quantity, sectionIds, onDone) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || T.strings.error);
        updateCounts(res.json.item_count);
        if (onDone) onDone(res.json);
        return res.json;
      })
      .catch(function (err) { toast(err.message || T.strings.error); });
  }

  /* Drawer quantity / remove */
  var drawerChange = debounce(function (line, qty) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.setAttribute('aria-busy', 'true');
    changeLine(line, qty, ['cart-drawer'], function (json) {
      if (json.sections) applyDrawerSection(json.sections['cart-drawer']);
    }).finally(function () { if (inner) inner.removeAttribute('aria-busy'); });
  }, 300);

  /* Cart page quantity / remove */
  var pageChange = debounce(function (root, line, qty) {
    var sid = root.getAttribute('data-section-id');
    root.setAttribute('aria-busy', 'true');
    changeLine(line, qty, [sid], function (json) {
      if (json.sections && json.sections[sid]) {
        var doc = parseHtml(json.sections[sid]);
        var fresh = $('[data-main-cart]', doc);
        if (fresh) root.innerHTML = fresh.innerHTML;
      }
    }).finally(function () { root.removeAttribute('aria-busy'); });
  }, 300);

  function handleLineChange(input) {
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    var pageRoot = input.closest('[data-main-cart]');
    if (pageRoot) pageChange(pageRoot, line, qty);
    else if (input.closest('[data-cart-drawer-inner]')) drawerChange(line, qty);
  }

  on(document, 'click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    var line = parseInt(rm.getAttribute('data-line-remove'), 10);
    var pageRoot = rm.closest('[data-main-cart]');
    if (pageRoot) pageChange(pageRoot, line, 0);
    else drawerChange(line, 0);
  });

  on(document, 'change', function (e) {
    var input = e.target;
    if (input.matches && input.matches('[data-line-qty]')) handleLineChange(input);
    if (input.matches && input.matches('[data-cart-note]')) {
      fetch(T.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: input.value })
      }).catch(function () {});
    }
  });

  /* Quantity steppers (all contexts) */
  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var val = parseInt(input.value, 10) || 0;
    val = btn.hasAttribute('data-qty-plus') ? val + step : val - step;
    if (val < min) val = min;
    if (!isNaN(max) && val > max) val = max;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ */
  /* Wishlist (localStorage)                                             */
  /* ------------------------------------------------------------------ */
  var WKEY = 'hotdrawer-wishlist';
  function readWish() {
    try { var v = JSON.parse(window.localStorage.getItem(WKEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (err) { return []; }
  }
  function writeWish(list) {
    try { window.localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) { /* storage unavailable */ }
  }
  function syncWishUI() {
    var list = readWish();
    var handles = list.map(function (i) { return i.handle; });
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', handles.indexOf(btn.getAttribute('data-handle')) > -1 ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.setAttribute('data-count', list.length);
    });
  }
  function renderWishlist() {
    var box = $('[data-wishlist-list]');
    if (!box) return;
    var list = readWish();
    if (!list.length) {
      box.innerHTML = '<p class="empty-note">' + escapeHtml(T.strings.wishEmpty) + '</p>';
      return;
    }
    box.innerHTML = list.map(function (i) {
      var img = i.image
        ? '<img src="' + escapeHtml(i.image) + '" alt="" width="64" height="64" loading="lazy">'
        : '<span class="wish-item__ph" aria-hidden="true">🌿</span>';
      return '<div class="wish-item">' + img +
        '<div><a href="' + escapeHtml(i.url) + '">' + escapeHtml(i.title) + '</a><p>' + escapeHtml(i.price) + '</p></div>' +
        '<button type="button" class="icon-btn" data-wishlist-remove="' + escapeHtml(i.handle) + '" aria-label="' +
        escapeHtml(T.strings.remove) + ': ' + escapeHtml(i.title) + '">' +
        '<svg class="icon" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>';
    }).join('');
  }
  on(document, 'click', function (e) {
    var t = e.target.closest('[data-wishlist-toggle]');
    if (t) {
      e.preventDefault();
      var list = readWish();
      var h = t.getAttribute('data-handle');
      var idx = -1;
      list.forEach(function (i, n) { if (i.handle === h) idx = n; });
      if (idx > -1) { list.splice(idx, 1); toast(T.strings.wishRemoved); }
      else {
        list.unshift({
          handle: h,
          title: t.getAttribute('data-title'),
          url: t.getAttribute('data-url'),
          image: t.getAttribute('data-image'),
          price: t.getAttribute('data-price')
        });
        toast(T.strings.wishAdded);
      }
      writeWish(list.slice(0, 60));
      syncWishUI();
      renderWishlist();
      return;
    }
    var r = e.target.closest('[data-wishlist-remove]');
    if (r) {
      var rh = r.getAttribute('data-wishlist-remove');
      writeWish(readWish().filter(function (i) { return i.handle !== rh; }));
      syncWishUI();
      renderWishlist();
    }
  });

  /* ------------------------------------------------------------------ */
  /* Predictive search                                                   */
  /* ------------------------------------------------------------------ */
  function initPredictive(root) {
    var input = $('[data-predictive-input]', root);
    var box = $('[data-predictive-results]', root);
    if (!input || !box) return;
    var controller = null;
    var lastTerm = '';

    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function render(term, products) {
      var url = T.routes.search + '?q=' + encodeURIComponent(term) + '&type=product';
      var html = '';
      if (!products.length) {
        html = '<p class="predictive__empty">' + escapeHtml((T.strings.noResults || '').replace('[terms]', term)) + '</p>';
      } else {
        html = '<ul class="predictive__list" role="listbox" id="' + box.id + '-list">' + products.map(function (p, n) {
          var src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          var img = src
            ? '<img class="predictive__img" src="' + escapeHtml(src) + '" alt="" width="48" height="48" loading="lazy">'
            : '<span class="predictive__img" aria-hidden="true">🌿</span>';
          var cents = Math.round(parseFloat(p.price) * 100);
          return '<li class="predictive__item" role="option" id="' + box.id + '-opt-' + n + '"><a href="' + escapeHtml(p.url) + '" tabindex="-1">' + img +
            '<span><span class="predictive__title">' + escapeHtml(p.title) + '</span><br><span class="predictive__price">' +
            escapeHtml(formatMoney(cents)) + '</span></span></a></li>';
        }).join('') + '</ul>';
      }
      html += '<a class="predictive__all" href="' + escapeHtml(url) + '">' + escapeHtml((T.strings.viewAll || 'View all results').replace('[terms]', term)) +
        '<svg class="icon" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    var search = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { close(); return; }
      if (term === lastTerm && !box.hidden) return;
      lastTerm = term;
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = T.routes.predictiveSearch + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var products = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          render(term, products);
        })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }, 250);

    on(input, 'input', search);
    on(input, 'focus', function () { if (input.value.trim().length >= 2) search(); });
    on(input, 'keydown', function (e) {
      var links = $$('.predictive__item a, .predictive__all', box);
      if (e.key === 'Escape') { close(); return; }
      if (box.hidden || !links.length) return;
      var current = links.indexOf($('[aria-selected="true"]', box));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var next = e.key === 'ArrowDown' ? current + 1 : current - 1;
        if (next < 0) next = links.length - 1;
        if (next >= links.length) next = 0;
        links.forEach(function (l) { l.removeAttribute('aria-selected'); });
        links[next].setAttribute('aria-selected', 'true');
        links[next].scrollIntoView({ block: 'nearest' });
        var li = links[next].closest('li');
        if (li && li.id) input.setAttribute('aria-activedescendant', li.id);
        else input.removeAttribute('aria-activedescendant');
      } else if (e.key === 'Enter' && current > -1) {
        e.preventDefault();
        window.location.href = links[current].href;
      }
    });
    on(document, 'click', function (e) { if (!root.contains(e.target)) close(); });
    on(root, 'focusout', function (e) { if (e.relatedTarget && !root.contains(e.relatedTarget)) close(); });
  }

  /* ------------------------------------------------------------------ */
  /* Product: gallery, variants, tabs                                    */
  /* ------------------------------------------------------------------ */
  function initGallery(root) {
    var slides = $$('[data-gallery-slide]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    if (!slides.length) return null;
    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function pauseMedia(slide) {
      $$('video', slide).forEach(function (v) { try { v.pause(); } catch (err) {} });
      $$('iframe', slide).forEach(function (f) {
        try {
          f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          f.contentWindow.postMessage('{"method":"pause"}', '*');
        } catch (err) {}
      });
    }
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      slides.forEach(function (s, n) {
        var active = n === i;
        if (!active && s.classList.contains('is-active')) pauseMedia(s);
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach(function (t, n) {
        if (n === i) {
          t.setAttribute('aria-current', 'true');
          t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        } else t.removeAttribute('aria-current');
      });
      index = i;
    }
    thumbs.forEach(function (t, n) { on(t, 'click', function () { go(n); }); });
    on($('[data-gallery-prev]', root), 'click', function () { go(index - 1); });
    on($('[data-gallery-next]', root), 'click', function () { go(index + 1); });
    var stage = $('[data-gallery-stage]', root);
    on(stage, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });
    /* swipe */
    var sx = null;
    on(stage, 'touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    on(stage, 'touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
      sx = null;
    });
    return {
      goToMedia: function (mediaId) {
        var n = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
        if (n > -1) go(n);
      }
    };
  }

  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var gallery = initGallery(root);
    var form = $('form.js-product-form', root);
    var idInput = form && $('input[name="id"]', form);
    var addBtn = form && $('[data-add-button]', form);
    var addLabel = addBtn && $('[data-add-label]', addBtn);
    var buyBtn = $('[data-buy-now]', root);
    var lowThreshold = parseInt(root.getAttribute('data-low-stock'), 10) || 0;
    var groups = $$('[data-option-index]', root);
    var wishLink = $('[data-wishlist-toggle]', root);

    function selected() {
      return groups.map(function (g) {
        var c = $('input:checked', g);
        var s = $('select', g);
        return c ? c.value : (s ? s.value : null);
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        $$('[data-option-value]', g).forEach(function (wrap) {
          var val = wrap.getAttribute('data-option-value');
          var test = opts.slice();
          test[gi] = val;
          var match = data.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          var ok = !!(match && match.available);
          wrap.classList.toggle('is-unavailable', !ok);
          var input = $('input', wrap);
          if (input) input.setAttribute('aria-description', ok ? '' : (T.strings.unavailable || 'Unavailable'));
        });
        var label = $('[data-selected-value]', g);
        if (label) label.textContent = opts[gi] || '';
      });
    }
    function setText(sel, text, hide) {
      $$(sel, root).forEach(function (el) {
        el.textContent = text;
        if (hide !== undefined) el.hidden = hide;
      });
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = T.strings.unavailable;
        if (buyBtn) buyBtn.disabled = true;
        setText('[data-stock]', T.strings.unavailable);
        return;
      }
      if (idInput) idInput.value = v.id;
      $$('[data-price]', root).forEach(function (el) { el.textContent = formatMoney(v.price); el.classList.toggle('price--sale', v.compare_at_price > v.price); });
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      setText('[data-compare]', onSale ? formatMoney(v.compare_at_price) : '', !onSale);
      var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      setText('[data-off]', onSale ? (T.strings.off || '[percent]% OFF').replace('[percent]', pct) : '', !onSale);
      setText('[data-sku]', v.sku ? ('SKU: ' + v.sku) : '', !v.sku);
      $$('[data-unit-price]', root).forEach(function (el) {
        el.hidden = !v.unit_price;
        if (v.unit_price) el.textContent = formatMoney(v.unit_price) + ' / ' + (v.unit_ref || '');
      });

      $$('[data-stock]', root).forEach(function (el) {
        el.classList.remove('is-low', 'is-out');
        if (!v.available) { el.textContent = T.strings.outOfStock; el.classList.add('is-out'); }
        else if (v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0 && v.inventory_quantity <= lowThreshold) {
          el.textContent = (T.strings.lowStock || '').replace('[count]', v.inventory_quantity);
          el.classList.add('is-low');
        } else { el.textContent = T.strings.inStock; }
      });

      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? addLabel.getAttribute('data-default') : T.strings.soldOut;
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (gallery && v.featured_media_id) gallery.goToMedia(v.featured_media_id);
      if (wishLink) wishLink.setAttribute('data-price', formatMoney(v.price));

      if (root.hasAttribute('data-update-url') && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: v }));
    }
    groups.forEach(function (g) { on(g, 'change', update); });
    if (groups.length) markAvailability(selected());
  }

  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var active = t === tab;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      on(t, 'click', function () { select(t); });
      on(t, 'keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(tabs[n], true); }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Product recommendations                                             */
  /* ------------------------------------------------------------------ */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    var sectionWrap = el.closest('.shopify-section');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = parseHtml(text);
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.getAttribute('data-has-products') === 'true') {
          el.innerHTML = fresh.innerHTML;
          el.setAttribute('data-has-products', 'true');
          syncWishUI();
        } else if (sectionWrap) {
          sectionWrap.remove();
        } else {
          el.remove();
        }
      })
      .catch(function () { if (sectionWrap) sectionWrap.remove(); });
  }

  /* ------------------------------------------------------------------ */
  /* Collection filters & sorting                                        */
  /* ------------------------------------------------------------------ */
  function navigateWithForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    window.location.href = form.getAttribute('action') + '?' + params.toString();
  }
  on(document, 'change', function (e) {
    var form = e.target.closest && e.target.closest('[data-facets-form]');
    if (form) {
      if (e.target.type === 'number') debouncedNav(form);
      else navigateWithForm(form);
      return;
    }
    if (e.target.matches && e.target.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });
  var debouncedNav = debounce(navigateWithForm, 700);

  on(document, 'click', function (e) {
    var t = e.target.closest('[data-toggle-target]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-toggle-target'));
    if (!target) return;
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    target.classList.toggle('is-open', open);
    if (target.hasAttribute('hidden') || target.hasAttribute('data-toggle-hidden')) {
      target.hidden = !open;
      target.setAttribute('data-toggle-hidden', '');
    }
  });

  /* ------------------------------------------------------------------ */
  /* Customer address country/province                                   */
  /* ------------------------------------------------------------------ */
  function initCountrySelect(country) {
    var form = country.closest('form');
    var province = form && $('[data-province-select]', form);
    var wrap = form && $('[data-province-wrap]', form);
    if (!province) return;
    var def = country.getAttribute('data-default');
    if (def) {
      $$('option', country).forEach(function (o) { if (o.value === def || o.textContent === def) country.value = o.value; });
    }
    function fill() {
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (err) {}
      province.innerHTML = list.map(function (p) {
        return '<option value="' + escapeHtml(p[0]) + '">' + escapeHtml(p[1]) + '</option>';
      }).join('');
      var pdef = province.getAttribute('data-default');
      if (pdef) province.value = pdef;
      if (wrap) wrap.hidden = !list.length;
    }
    on(country, 'change', function () { province.setAttribute('data-default', ''); fill(); });
    fill();
  }

  /* ------------------------------------------------------------------ */
  /* Header, back to top                                                 */
  /* ------------------------------------------------------------------ */
  on(document, 'click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var nav = document.getElementById(t.getAttribute('aria-controls'));
    if (!nav) return;
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.classList.toggle('is-open', open);
  });

  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn) return;
    var toggle = function () { btn.hidden = window.scrollY < 600; };
    on(window, 'scroll', debounce(toggle, 80), { passive: true });
    toggle();
    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      var main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function initScope(scope) {
    $$('[data-predictive]', scope).forEach(initPredictive);
    $$('[data-product-root]', scope).forEach(initProduct);
    $$('[data-tabs]', scope).forEach(initTabs);
    $$('[data-recommendations]', scope).forEach(initRecommendations);
    $$('[data-country-select]', scope).forEach(initCountrySelect);
    syncWishUI();
  }
  T.initScope = initScope;

  function boot() {
    initScope(document);
    initBackToTop();
    renderWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initScope(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) openDrawer($('#CartDrawer'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('#CartDrawer')) closeDrawer($('#CartDrawer'));
  });
})();
